import i from"styled-components";const o=i.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	border-radius: ${({borderRadius:i})=>`${i}px`};
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	background-color: ${({backgroundColor:i})=>i};
	color: ${({color:i})=>i};
	padding: 16px;
	height: 100%;
	box-sizing: border-box;
`,e=i.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 24px;
	height: 100%;
`,n=i.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`,t=i.h1`
	font-size: 22px;
	margin: 0;
	font-weight: 600;
	cursor: ${({isEditable:i=!1})=>i?"text":"default"};
`,r=i.p`
	font-size: 14px;
	margin: 0;
	font-weight: 400;
	opacity: 0.6;
	line-height: 18px;
	cursor: ${({isEditable:i=!1})=>i?"text":"default"};
	outline: none;
`,d=i.div`
	display: flex;
	align-items: center;
	justify-content: ${({hasLink:i})=>i?"space-between":"flex-end"};
`,l=i.span`
	font-size: 14px;
	font-weight: 400;
	color: ${({color:i})=>i};
	background-color: ${({backgroundColor:i})=>i};
	cursor: ${({isEditable:i=!1})=>i?"text":"default"};
	padding: 5px 10px;
	border-radius: 9999px;
	width: fit-content;
	max-width: 80%;
	text-overflow: ellipsis;
	overflow: hidden;
	display: inline-block;
`,p=i.div`
	background: url(${({imageUrl:i})=>i});
	background-size: cover;
	background-position: ${({position:i})=>i?`${i.x}% ${i.y}%`:"center"};
	border-radius: ${({borderRadius:i})=>i-3+"px"};
	position: relative;

	${({isOneColumn:i})=>i?"\n      width: 284px;\n      min-height: 241px;\n      ":"\n      min-height: 170px;\n  "}
`;export{e as CardBody,o as CardContainer,n as CardContentContainer,p as CardCover,d as CardFooter,t as CardHeading,l as CardLabel,r as CardParagraph};
